export default "__VITE_ASSET__JrHga9OX__"